import Transmission from "../../../utils/services/project/metering/transmissionService";
import crudTemplate from "../../../templates/crudTemplate";

let crud = crudTemplate(Transmission);

function prepareItem(item, rootGetters) {
  let sources = rootGetters["projectMeteringStore/sourceStore/getList"];
  item.source_id = item._source && item._source.id;
  item.project_id = item._project && item._project.id;
  if (item.source_id) {
    item.source_name = (sources.find(i => i.id === item.source_id) || {}).name;
  }
  return item;
}

const state = {
  ...crud.state
};
const getters = {
  ...crud.getters,
  getList(state, getters, rootState, rootGetters) {
    let list = crud.getters.getList(state);
    return list.map(item => prepareItem(item, rootGetters));
  },
  getItem(state, getters, rootState, rootGetters) {
    let item = crud.getters.getItem(state);
    return prepareItem(item, rootGetters);
  }
};

const actions = {
  ...crud.actions,
  reprocess(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    return Transmission.reprocess(
      {
        ...item
      },
      onSuccess,
      () => {},
      errorHandler
    );
  },
  testFilter(_, { params, errorHandler = () => {}, onSuccess = () => {} }) {
    return Transmission.testFilter(
      {
        ...params
      },
      onSuccess,
      () => {},
      errorHandler
    );
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
